import {Component} from 'react'
import {Link} from 'react-router-dom'
import Cookies from 'js-cookie'
import Loader from 'react-loader-spinner'
import ReactPlayer from 'react-player'
import ThemeContext from '../../context/ThemeContext'
import './index.css'

class VideoItemDetailsRoute extends Component {
  state = {
    videoData: null,
    isLoading: true,
    isSaved: false,
    isLiked: false,
    isDisliked: false,
    error: null,
  }

  componentDidMount() {
    this.getVideoData()
  }

  getVideoData = async () => {
    const jwtToken = Cookies.get('jwt_token')
    const {match, history} = this.props

    if (!jwtToken) {
      history.replace('/login')
      return
    }

    const {id} = match.params
    const url = `https://apis.ccbp.in/videos/${id}`
    const options = {
      method: 'GET',
      headers: {Authorization: `Bearer ${jwtToken}`},
    }

    try {
      const response = await fetch(url, options)
      if (response.ok) {
        const data = await response.json()
        const videoDetails = {
          id: data.video_details.id,
          title: data.video_details.title,
          videoUrl: data.video_details.video_url,
          thumbnailUrl: data.video_details.thumbnail_url,
          channelName: data.video_details.channel.name,
          channelLogo: data.video_details.channel.profile_image_url,
          subscribeCount: data.video_details.channel.subscriber_count,
          viewCount: data.video_details.view_count,
          publishedAt: data.video_details.published_at,
          description: data.video_details.description,
        }

        let savedVideos = []
        try {
          savedVideos = Cookies.get('saved_videos')
            ? JSON.parse(Cookies.get('saved_videos'))
            : []
        } catch {
          savedVideos = []
        }

        const isSaved = savedVideos.some(v => v.id === videoDetails.id)
        this.setState({
          videoData: videoDetails,
          isLoading: false,
          isSaved,
          error: null,
        })
      } else {
        this.setState({
          isLoading: false,
          error: 'Failed to load video',
        })
      }
    } catch (err) {
      this.setState({
        isLoading: false,
        error: 'An error occurred while fetching the video',
      })
    }
  }

  toggleSave = () => {
    const {videoData, isSaved} = this.state
    let savedVideos = []
    try {
      savedVideos = Cookies.get('saved_videos')
        ? JSON.parse(Cookies.get('saved_videos'))
        : []
    } catch {
      savedVideos = []
    }

    if (!isSaved) {
      savedVideos.push(videoData)
    } else {
      savedVideos = savedVideos.filter(video => video.id !== videoData.id)
    }

    Cookies.set('saved_videos', JSON.stringify(savedVideos), {expires: 7})
    this.setState(prevState => ({isSaved: !prevState.isSaved}))
  }

  toggleLike = () => {
    this.setState(prevState => ({
      isLiked: !prevState.isLiked,
      isDisliked: false,
    }))
  }

  toggleDislike = () => {
    this.setState(prevState => ({
      isLiked: false,
      isDisliked: !prevState.isDisliked,
    }))
  }

  renderLoadingView = () => (
    <div className="loader-container" data-testid="loader">
      <Loader type="ThreeDots" color="#000" height={50} width={50} />
    </div>
  )

  renderErrorView = isDarkTheme => {
    const errorBg = isDarkTheme
      ? 'error-container-dark'
      : 'error-container-light'
    const errorText = isDarkTheme ? 'error-text-dark' : 'error-text-light'

    return (
      <div className={`error-container ${errorBg}`}>
        <button
          type="button"
          onClick={this.getVideoData}
          className="retry-button"
        >
          Retry
        </button>
      </div>
    )
  }

  render() {
    const {videoData, isLoading, isSaved, isLiked, isDisliked, error} =
      this.state

    if (isLoading) {
      return this.renderLoadingView()
    }

    return (
      <ThemeContext.Consumer>
        {value => {
          const {isDarkTheme} = value

          if (error || !videoData) {
            return this.renderErrorView(isDarkTheme)
          }

          const textColor = isDarkTheme ? 'video-text-dark' : 'video-text-light'
          const containerBg = isDarkTheme
            ? 'video-detail-container-dark'
            : 'video-detail-container-light'
          const hrColor = isDarkTheme ? 'hr-dark' : 'hr-light'
          const likeColor = isLiked ? '#2563eb' : '#64748b'
          const dislikeColor = isDisliked ? '#2563eb' : '#64748b'
          const saveColor = isSaved ? '#2563eb' : '#64748b'

          return (
            <div className={`video-container ${containerBg}`}>
              <ReactPlayer
                url={videoData.videoUrl}
                controls
                width="100%"
                height="400px"
              />
              <p className={`video-title ${textColor}`}>{videoData.title}</p>

              <div className="likedislike">
                <p className={`video-stats ${textColor}`}>
                  {videoData.viewCount} views • {videoData.publishedAt}
                </p>
                <div className="video-actions">
                  <button
                    type="button"
                    onClick={this.toggleLike}
                    style={{color: likeColor}}
                    data-testid="like-button"
                    className="action-button"
                  >
                    Like
                  </button>
                  <button
                    type="button"
                    onClick={this.toggleDislike}
                    style={{color: dislikeColor}}
                    data-testid="dislike-button"
                    className="action-button"
                  >
                    Dislike
                  </button>
                  <button
                    type="button"
                    onClick={this.toggleSave}
                    style={{color: saveColor}}
                    data-testid="save-button"
                    className="action-button"
                  >
                    {isSaved ? 'Saved' : 'Save'}
                  </button>
                </div>
              </div>

              <hr className={hrColor} />

              <div className="video-info">
                <img
                  src={videoData.channelLogo}
                  alt="channel logo"
                  className="channel-logo"
                />
                <div className={`channel-details ${textColor}`}>
                  <p className="channel-name">{videoData.channelName}</p>
                  <p className="subscriber-count">
                    {videoData.subscribeCount} subscribers
                  </p>
                </div>
              </div>

              <p className={`video-description ${textColor}`}>
                {videoData.description}
              </p>

              <div className="navigation-links">
                <Link to="/saved-videos" className="nav-link">
                  Go to Saved Videos
                </Link>
              </div>
            </div>
          )
        }}
      </ThemeContext.Consumer>
    )
  }
}

export default VideoItemDetailsRoute
